/**
 * IAN Dark Theme — Fluent UI v9 custom theme
 * Extends webDarkTheme with IAN brand overrides.
 */
import { webDarkTheme } from '@fluentui/react-components';

export const ianDarkTheme = {
  ...webDarkTheme,

  // Brand (same amber in dark)
  colorBrandBackground: '#FFB500',
  colorBrandBackgroundHover: '#E6A300',
  colorBrandBackgroundPressed: '#CC9200',
  colorBrandBackgroundSelected: '#FFB500',
  colorBrandForeground1: '#FFB500',
  colorBrandForeground2: '#E6A300',
  colorBrandForegroundLink: '#47BEF0',
  colorBrandForegroundLinkHover: '#7DD1F5',
  colorBrandStroke1: '#FFB500',
  colorBrandStroke2: '#E6A300',

  // Surfaces (dark)
  colorNeutralBackground1: '#0B111A',
  colorNeutralBackground1Hover: '#2A3750',
  colorNeutralBackground1Selected: '#3D2E00',
  colorNeutralBackground2: '#141C28',
  colorNeutralBackground3: '#1C2636',
  colorNeutralCardBackground: '#232F42',
  colorNeutralCardBackgroundHover: '#2A3750',

  // Text (dark)
  colorNeutralForeground1: '#F0F1F3',
  colorNeutralForeground2: '#B0B5BD',
  colorNeutralForeground3: '#7A808A',
  colorNeutralForegroundDisabled: '#4A4F57',
  colorNeutralForegroundOnBrand: '#0B111A',

  // Borders (dark)
  colorNeutralStroke1: '#2A3750',
  colorNeutralStroke2: '#3A4A64',
  colorStrokeFocus2: '#47BEF0',

  // Semantic (dark)
  colorPaletteRedBackground1: '#2B0D0D',
  colorPaletteRedForeground1: '#FF7070',
  colorPaletteGreenBackground1: '#0D2B0D',
  colorPaletteGreenForeground1: '#7ED956',
  colorPaletteYellowBackground1: '#2B2200',
  colorPaletteYellowForeground1: '#FFB500',

  // Compound brand
  colorCompoundBrandBackground: '#FFB500',
  colorCompoundBrandBackgroundHover: '#E6A300',
  colorCompoundBrandBackgroundPressed: '#CC9200',
  colorCompoundBrandForeground1: '#FFB500',
  colorCompoundBrandStroke: '#FFB500',

  // Subtle
  colorSubtleBackground: 'transparent',
  colorSubtleBackgroundHover: '#2A3750',
  colorSubtleBackgroundPressed: '#1C2636',
  colorSubtleBackgroundSelected: '#3D2E00',

  // Typography
  fontFamilyBase: "'Avenir Next LT Pro', 'Avenir Next', 'Avenir', 'Segoe UI', 'Helvetica Neue', sans-serif",

  // Shadows (dark)
  shadow2: '0 1px 2px rgba(0,0,0,0.3)',
  shadow4: '0 2px 4px rgba(0,0,0,0.3)',
  shadow8: '0 4px 8px rgba(0,0,0,0.4)',
  shadow16: '0 8px 16px rgba(0,0,0,0.45)',
  shadow28: '0 8px 24px rgba(0,0,0,0.5)',
  shadow64: '0 16px 48px rgba(0,0,0,0.6)',
};

export default ianDarkTheme;
